export default __webpack_public_path__ + "resources/icons/n410-e069.png";